<template>
	<div
		class="d-flex flex-row nowrap pb-2"
		style="gap: 10px; overflow-x: auto; max-width: 100%; max-width: 90vw"
	>
		<div
			@click.stop="() => handleItemClick(item_i)"
			v-for="(item, item_i) in filterItems"
			class="tab filter-item cursor-pointer text-nowrap"
			:class="currentFilterItemIndex === item_i && 'tab-selected'"
			:key="item_i"
		>
			{{ item.label }}
		</div>
	</div>
</template>

<script>
export default {
	name: "Filter",
	props: {
		filterItems: Array,
		currentFilterItemIndex: Number,
	},
	methods: {
		handleItemClick(item_i) {
			this.$emit("filter", item_i);
		},
	},
};
</script>

<style>
.tab {
	min-width: 180px;
}
.filter-item {
	/* background-color: rgba(0,0,0,0.025) !important; */
	padding: 10px;
	min-width: 180px;
	height: 30px;
}
</style>
